import { Resource } from '@app/http/resource/resource.model';
// tslint:disable: variable-name

export class RecaptchaEvent extends Resource {
  // id is inherited from Resource
  token: string;
  secret_key: string;
  active: boolean;
  type: string;
  portal_id: number;
  main_setting_id: number
  edited_by: string;
  updated_at: Date;
}
